import React from "react";
import {
    CTContainer,
    CTTContainerTitulo,
    CTTitulo,
    CardListContact,
    CardContact,
    CardContactP1,
    CardContactP2,
    CardContactP3,
    ButtonContact,
    PIniciar,
    ContainerPs,
    ContainerButton,
    ContainerSocial,
    PSocial,
    ContactSocial
} from '../Contact.style';

function Contato({ item, DadosAPI }) {

    const contact = [
        {
            titulo: 'WhatsApp',
            descricao: 'Clique no botão abaixo e você será \n redirecionado para nossos atendentes.',
            disponibilidade: 'Seg à Sex. - 9h às 18h',
            disponibilidade2: 'Sábados. - 9h às 14h',
            bgButton: '#000000',
            colorText: '#FFFFFF',
            textButton: 'Iniciar',
            url: `https://wa.me/55${DadosAPI.cabecalho[0].telefone.replace(/\D/g, '')}?text=Olá,%20gostaria%20de%20mais%20informações!`,
        },
        {
            titulo: 'E-mail',
            descricao: 'Entre em contato com nosso time pelo \n e-mail parar tirar dúvidas ou pedir ajuda.',
            disponibilidade: '7/24h',
            bgButton: '#000000',
            colorText: '#FFFFFF',
            textButton: 'Iniciar',
            url: `mailto:${DadosAPI.cabecalho[0].emailcontato}`,
        }
    ];

    const social = [
        { name: 'Facebook', icon: "https://upload.wikimedia.org/wikipedia/commons/b/b9/2023_Facebook_icon.svg" },
        { name: 'Instagram', icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/1200px-Instagram_icon.png" },
        { name: 'Linkedin', icon: "https://cdn1.iconfinder.com/data/icons/logotypes/32/circle-linkedin-512.png" },
    ]

    return (
        <CTContainer>
            <CTTContainerTitulo>
                <CTTitulo style={{ whiteSpace: 'pre-line' }}>{DadosAPI.pagina.paginaitem[0].ecommercepaginaitem}</CTTitulo>
            </CTTContainerTitulo>
            <CardListContact>
                {contact.map((section) => (
                    <CardContact key={section.id}>
                        <div>
                            <ContainerPs>
                                <CardContactP1>{section.titulo}</CardContactP1>
                                <CardContactP2 style={{ whiteSpace: 'pre-line' }}>{section.descricao}</CardContactP2>
                                <CardContactP3>{section.disponibilidade}</CardContactP3>
                                <CardContactP3>{section.disponibilidade2}</CardContactP3>
                            </ContainerPs>
                            <ContainerButton>
                                <ButtonContact onClick={() => window.open(section.url, '_blank')} style={{ background: section.bgButton }}>
                                    <PIniciar style={{ color: section.colorText }}>{section.textButton}</PIniciar>
                                </ButtonContact>
                            </ContainerButton>
                        </div>
                    </CardContact>
                ))}
            </CardListContact>
            <ContainerSocial>
                <PSocial>{'Pensamos nas melhores formas de contato para você não ter dificuldades no momento que mais precisa!'}</PSocial>
                <ContactSocial>
                    {DadosAPI.redesocial.map((i) => {
                        const match = social.find((s) => s.name === i.redesocial);
                        return match ?
                            <a key={i.name} href={i.ecommerceredesocial} target="_blank" rel="noopener noreferrer">
                                <img style={{ width: 30 }} src={match.icon} alt={i.name} />
                            </a> : null;
                    })}
                </ContactSocial>
            </ContainerSocial>
        </CTContainer>
    );
}

export default Contato;
